var exports = {
  "b": "xaee3c4fa--97117c--thumbs-gallery",
  "M6": "xaee3c4fa--97117c--slide",
  "_J": "xaee3c4fa--97117c--is-active",
};

module.exports = exports;
